import React from "react";
import { Clock } from "@phosphor-icons/react";

const DAYS = [
    { key: "mon", label: "Mon" },
    { key: "tue", label: "Tue" },
    { key: "wed", label: "Wed" },
    { key: "thu", label: "Thu" },
    { key: "fri", label: "Fri" },
    { key: "sat", label: "Sat" },
    { key: "sun", label: "Sun" },
];

const SLOTS = [
    { key: "08-10", label: "8–10 AM" },
    { key: "10-12", label: "10–12" },
    { key: "12-14", label: "12–2 PM" },
    { key: "14-16", label: "2–4 PM" },
    { key: "16-18", label: "4–6 PM" },
];

export default function WeeklyAvailabilityEditor({ value, onChange }) {
    const safe = value || {};
    const isSet = (day, slot) => (safe[day] || []).includes(slot);

    function toggle(day, slot) {
        const current = safe[day] || [];
        const next = current.includes(slot)
            ? current.filter((s) => s !== slot)
            : [...current, slot];
        onChange({ ...safe, [day]: next });
    }

    function applyWeekday() {
        // Copy Mon's slots to Tue–Fri
        const mon = safe.mon || [];
        const next = { ...safe, tue: [...mon], wed: [...mon], thu: [...mon], fri: [...mon] };
        onChange(next);
    }

    function clearAll() {
        onChange({});
    }

    return (
        <div data-testid="weekly-availability-editor" className="space-y-4">
            <p className="text-xs text-slate-400">
                Toggle the 2-hour windows you're available each week. Clients pick from these when scheduling.
            </p>
            <div className="flex gap-2 text-xs">
                <button
                    type="button"
                    data-testid="copy-mon-to-weekday"
                    onClick={applyWeekday}
                    className="px-3 py-1.5 rounded-sm border border-white/10 text-slate-300 hover:border-gold/50 hover:text-gold"
                >
                    Copy Mon → Tue–Fri
                </button>
                <button
                    type="button"
                    data-testid="clear-availability"
                    onClick={clearAll}
                    className="px-3 py-1.5 rounded-sm border border-white/10 text-slate-300 hover:border-red-400/50 hover:text-red-300"
                >
                    Clear all
                </button>
            </div>
            <div className="overflow-x-auto">
                <table className="w-full min-w-[480px] text-sm">
                    <thead>
                        <tr className="text-[10px] uppercase tracking-widest text-slate-500">
                            <th className="text-left px-2 py-2"><Clock size={12} weight="bold" className="inline mr-1" />Day</th>
                            {SLOTS.map((s) => (
                                <th key={s.key} className="px-2 py-2 text-center">{s.label}</th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {DAYS.map((d) => (
                            <tr key={d.key} className="border-t border-white/5">
                                <td className="px-2 py-2 text-slate-300 font-medium">{d.label}</td>
                                {SLOTS.map((s) => {
                                    const on = isSet(d.key, s.key);
                                    return (
                                        <td key={s.key} className="px-1 py-1 text-center">
                                            <button
                                                type="button"
                                                data-testid={`slot-${d.key}-${s.key}`}
                                                onClick={() => toggle(d.key, s.key)}
                                                className={`w-full px-2 py-2 rounded-sm border text-xs transition ${
                                                    on
                                                        ? "border-gold/60 bg-gold/15 text-gold"
                                                        : "border-white/10 text-slate-500 hover:border-white/25 hover:text-slate-300"
                                                }`}
                                                aria-label={`${d.label} ${s.label}`}
                                            >
                                                {on ? "✓" : "·"}
                                            </button>
                                        </td>
                                    );
                                })}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}
